// ===========================================================================
// Care Management System (Patient Profiles) — feature flag del módulo.
//
// DEV-ONLY desde 2026-08-31: el módulo queda fuera de producción hasta nuevo
// aviso. El gating se hace contra `process.env.NODE_ENV`, igual que playground,
// membership y cash:
//   - `yarn start`  → NODE_ENV = "development"  → PATIENT_PROFILES_ENABLED = true
//   - `yarn build`  → NODE_ENV = "production"   → PATIENT_PROFILES_ENABLED = false
//
// ANTES el ítem del sidebar ya estaba oculto en producción, pero la RUTA se
// montaba igual: cualquier autenticado con el módulo concedido entraba por URL
// directa. Ahora el módulo no publica rutas fuera de desarrollo, que es lo que
// convierte "oculto" en "inaccesible".
//
// El módulo conserva su mapeo RBAC (`patient_profiles`, 18) en
// app/AccessDenied/roleRoutePermissions.js: en desarrollo la ruta sigue
// gateada, y cuando se reactive en producción no hay nada más que tocar.
//
// PARA REACTIVARLO EN PRODUCCIÓN: cambiar esta constante por `true` (o por la
// condición que corresponda) — el índice del módulo y el sidebar la leen los dos.
// ===========================================================================

export const PATIENT_PROFILES_ENABLED = process.env.NODE_ENV === "development";

export const PATIENT_PROFILES_BASE_PATH = "/patient-profiles";
